"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Emitter = void 0;
function getEventTarget() {
    try {
        return window.EventTarget ? new window.EventTarget() : document.createElement('div');
    }
    catch (e) {
        return document.createElement('div');
    }
}
function getCustomEvent(type, detail) {
    if (window.CustomEvent) {
        return new window.CustomEvent(type, { detail: detail });
    }
    var e = document.createEvent('CustomEvent');
    e.initCustomEvent(type, undefined, undefined, detail);
    return e;
}
var Emitter = /** @class */ (function () {
    function Emitter() {
        this.inner = getEventTarget();
    }
    Emitter.prototype.on = function (type, callback, options) {
        var _this = this;
        var realCallback = function (e) {
            var value = (e instanceof CustomEvent) ? e.detail : e;
            callback(value);
        };
        var canceller = function () { return _this.inner.removeEventListener(type, realCallback, options); };
        this.inner.addEventListener(type, realCallback, options);
        return canceller;
    };
    Emitter.prototype.once = function (type, callback, options) {
        var _this = this;
        var realCallback = function (e) {
            var value = (e instanceof CustomEvent) ? e.detail : e;
            callback(value);
            canceller();
        };
        var canceller = function () { return _this.inner.removeEventListener(type, realCallback, options); };
        this.inner.addEventListener(type, realCallback, options);
        return canceller;
    };
    Emitter.prototype.emit = function (type, detail) {
        var e = getCustomEvent(type, detail);
        return this.inner.dispatchEvent(e);
    };
    return Emitter;
}());
exports.Emitter = Emitter;
//# sourceMappingURL=Emitter.js.map